import React from 'react'
import ProjectsBoard from '../../components/ProjectsBoard'
import { RateCurrencyContextProvider } from 'constants/rateCurrencyContextProvider'

function Board() {
  return (
    <RateCurrencyContextProvider>
      <ProjectsBoard />
    </RateCurrencyContextProvider>
  )
}

export default Board
